import { RouteKeys } from '../domain/RouteKeys';

export const NavBarConfig = [
    { path: RouteKeys.RSVP, icon: '☏', label: 'RSVP' },
    { path: RouteKeys.COUPLE, icon: '♡', label: 'Couple' },
    { path: RouteKeys.EVENTS, icon: '∞', label: 'Events' },
    { path: RouteKeys.DETAILS, icon: 'ⓘ', label: 'Details' },
];
  